export const NOT_IN_FIAS_TEXT = 'Введённый адрес отсутствует в справочнике ФИАС!';
